import type { MessageDescriptor } from 'react-intl';

export type EditorAppearance = 'chromeless' | 'comment';
export type EditorCommentMode = 'create' | 'reply' | 'edit';
export type EditorCommentType = 'page' | 'inline' | 'edit-inline';

// Defined in /inline-comments & /comment
export type InlineCommentsMode = 'view-all' | 'view' | 'edit';

export type NotificationType = {
	i18nMessage: MessageDescriptor;
	appearance: NotificationAppearance;
};

type NotificationAppearance = 'info' | 'warning' | 'error' | 'confirmation' | 'change';

export type AfterEditorActivateCallback = (editorRef: HTMLElement | null) => void;

export enum CommentRendererLocation {
	COMMENTS_PANEL_INLINE = 'comments-panel-inline',
	COMMENTS_PANEL_OBJECT = 'comments-panel-object',
	STANDALONE_INLINE = 'standalone-inline',
	STANDALONE_OBJECT = 'standalone-object',
}
